module.exports = __webpack_public_path__ + "static/media/SIPE.15b515b0.png";